import React from 'react'

const Contact = () => {
  return (
    <div className="content-section" id="contact">
    <h2>Contact Us</h2>
    <p>Interested in our services or have questions? Contact us at <a href="mailto:info@pulseinnovas.com">info@pulseinnovas.com</a> to learn more.</p>
   </div>  )
}

export default Contact